import { render } from "./CartSuggestions.vue?vue&type=template&id=3c7be8b9&scoped=true"
import script from "./CartSuggestions.vue?vue&type=script&lang=js"
export * from "./CartSuggestions.vue?vue&type=script&lang=js"

import "./CartSuggestions.vue?vue&type=style&index=0&id=3c7be8b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7be8b9"]])

export default __exports__